<div #main class="main__layout" [class.sidebar-expanded]="!sidebarCollapsed">
  <app-sidebar
    [items]="menuItems"
    [collapsed]="sidebarCollapsed"
    [colorConfig]="sidebarColors"
    [autoExpandOnClick]="true"
    (collapsedChange)="sidebarCollapsed = $event">
  </app-sidebar>

  <div class="main__wrapper">
    <div #navbar class="main__navbar">
      <app-user-navbar></app-user-navbar>
    </div>

    <div #root class="main__content">
      <div class="my-5">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
